import {GraphQLClient} from 'graphql-request';

import {config} from '@/constants/config';

export const pipelineApi = new GraphQLClient(config.SPINAMP_PIPELINE_URL);
